// (function() {
//   if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return;

//   var PARAM_KEYS = [
//     'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid',
//     'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'
//   ];

//   function getParam(name) {
//     var m = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.search);
//     return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
//   }

//   PARAM_KEYS.forEach(function(key) {
//     var val = getParam(key);
//     if (val) {
//       try {
//         sessionStorage.setItem('track_' + key, val);
//       } catch (e) {}
//     }
//   });

//   // Optional: first landing + referrer
//   try {
//     if (!sessionStorage.getItem('track_landing_page')) {
//       sessionStorage.setItem('track_landing_page', window.location.href);
//     }
//     if (!sessionStorage.getItem('track_referrer')) {
//       sessionStorage.setItem('track_referrer', document.referrer || '');
//     }
//   } catch (e) {}
// })();

// document.addEventListener('DOMContentLoaded', function() {
//   if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return;

//   var PARAM_KEYS = [
//     'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid',
//     'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'
//   ];

//   function buildTrackingQuery() {
//     var parts = [];
//     PARAM_KEYS.forEach(function(key) {
//       try {
//         var val = sessionStorage.getItem('track_' + key);
//         if (val) {
//           parts.push(key + '=' + encodeURIComponent(val));
//         }
//       } catch (e) {}
//     });
//     return parts.length ? parts.join('&') : '';
//   }

//   var trackingQS = buildTrackingQuery();
//   if (!trackingQS) {
//     // Nothing to append; bail early
//     return;
//   }

//   // 2. Find all links to go.maximumk9service.com and append params
//   var anchors = document.querySelectorAll('a[href*="go.maximumk9service.com"]');

//   anchors.forEach(function(a) {
//     try {
//       var href = a.getAttribute('href');
//       if (!href) return;

//       // Handle relative vs absolute quickly
//       // If it's a relative URL (rare for GHL), skip, since your case is full URLs
//       if (href.indexOf('http') !== 0 && href.indexOf('//') !== 0) return;

//       // Separate hash if present
//       var hash = '';
//       var hashIndex = href.indexOf('#');
//       if (hashIndex !== -1) {
//         hash = href.substring(hashIndex);
//         href = href.substring(0, hashIndex);
//       }

//       var sep = href.indexOf('?') === -1 ? '?' : '&';
//       // Only append if these params aren't already present
//       if (href.indexOf('utm_source=') === -1 &&
//           href.indexOf('gclid=') === -1 &&
//           href.indexOf('fbclid=') === -1) {
//         href = href + sep + trackingQS;
//       }

//       a.setAttribute('href', href + hash);
//     } catch (e) {}
//   });
// });

(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (typeof sessionStorage === 'undefined') return;

  var PARAM_KEYS = [
    'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'
  ];

  var TARGET_HOST = 'go.maximumk9service.com';
  var DEBUG = true;

  function log() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[tracking-debug]');
    console.log.apply(console, args);
  }

  function warn() {
    if (!DEBUG) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[tracking-debug]');
    console.warn.apply(console, args);
  }

  function getParam(name) {
    try {
      var url = new URL(window.location.href);
      return url.searchParams.get(name);
    } catch (e) {
      warn('Failed reading URL param:', name, e);
      return null;
    }
  }

  function persistTrackingParams() {
    PARAM_KEYS.forEach(function (key) {
      var val = getParam(key);
      if (val) {
        try {
          sessionStorage.setItem('track_' + key, val);
          log('Stored', key, '=', val);
        } catch (e) {
          warn('Failed storing', key, e);
        }
      }
    });

    try {
      if (!sessionStorage.getItem('track_landing_page')) {
        sessionStorage.setItem('track_landing_page', window.location.href);
        log('Stored landing page');
      }
      if (!sessionStorage.getItem('track_referrer')) {
        sessionStorage.setItem('track_referrer', document.referrer || '');
        log('Stored referrer');
      }
    } catch (e) {
      warn('Failed storing landing/referrer', e);
    }
  }

  function getStoredTrackingObject() {
    var data = {};

    PARAM_KEYS.forEach(function (key) {
      try {
        var val = sessionStorage.getItem('track_' + key);
        if (val) data[key] = val;
      } catch (e) {
        warn('Failed reading sessionStorage for', key, e);
      }
    });

    try {
      var landing = sessionStorage.getItem('track_landing_page');
      var referrer = sessionStorage.getItem('track_referrer');
      if (landing) data.landing_page = landing;
      if (referrer) data.referrer = referrer;
    } catch (e) {
      warn('Failed reading landing/referrer', e);
    }

    return data;
  }

  function isTargetLink(href) {
    if (!href) return false;
    if (
      href.indexOf('tel:') === 0 ||
      href.indexOf('mailto:') === 0 ||
      href.indexOf('javascript:') === 0 ||
      href.indexOf('#') === 0
    ) {
      return false;
    }

    try {
      var url = new URL(href, window.location.origin);
      return url.hostname === TARGET_HOST;
    } catch (e) {
      warn('Invalid href skipped:', href, e);
      return false;
    }
  }

  function updateAnchor(anchor) {
    if (!anchor || !anchor.getAttribute) return;

    var rawHref = anchor.getAttribute('href');
    if (!isTargetLink(rawHref)) return;

    var trackingData = getStoredTrackingObject();
    var trackingKeys = Object.keys(trackingData);

    if (!trackingKeys.length) {
      log('No tracking data in sessionStorage; skipped', rawHref);
      return;
    }

    try {
      var url = new URL(rawHref, window.location.origin);
      var changed = false;

      trackingKeys.forEach(function (key) {
        var val = trackingData[key];
        if (!url.searchParams.has(key) && val) {
          url.searchParams.set(key, val);
          changed = true;
        }
      });

      var newHref = url.toString();

      if (anchor.href !== newHref) {
        anchor.setAttribute('href', newHref);
        anchor.setAttribute('data-tracking-patched', 'true');
        log('Updated href:', rawHref, '=>', newHref, anchor);
      } else {
        log('Already up to date:', newHref, anchor);
      }

      if (!changed) {
        log('Target link already had all tracking params:', newHref);
      }
    } catch (e) {
      warn('Failed updating anchor:', rawHref, e);
    }
  }

  function updateAllAnchors(context) {
    var root = context && context.querySelectorAll ? context : document;
    var anchors = root.querySelectorAll('a[href]');
    log('Scanning anchors:', anchors.length);

    anchors.forEach(function (anchor) {
      updateAnchor(anchor);
    });
  }

  function observeNewLinks() {
    if (typeof MutationObserver === 'undefined') {
      warn('MutationObserver not supported in this browser');
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (!node || node.nodeType !== 1) return;

            if (node.matches && node.matches('a[href]')) {
              updateAnchor(node);
            }

            if (node.querySelectorAll) {
              var nestedAnchors = node.querySelectorAll('a[href]');
              nestedAnchors.forEach(function (anchor) {
                updateAnchor(anchor);
              });
            }
          });
        }

        if (
          mutation.type === 'attributes' &&
          mutation.target &&
          mutation.target.tagName === 'A' &&
          mutation.attributeName === 'href'
        ) {
          updateAnchor(mutation.target);
        }
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['href']
    });

    log('MutationObserver started');
  }

  function init() {
    log('Init start');
    persistTrackingParams();
    updateAllAnchors(document);
    observeNewLinks();

    window.__maxK9TrackingDebug = {
      updateAllAnchors: updateAllAnchors,
      getStoredTrackingObject: getStoredTrackingObject,
      persistTrackingParams: persistTrackingParams
    };

    log('Init done. Debug helper available at window.__maxK9TrackingDebug');
    log('Stored tracking object:', getStoredTrackingObject());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();